import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import { SIGN_IN_PATH } from 'routes/constants.routes'
import { HomeStoreProviderRop } from 'context/HomeStore/Rop'
import { useAuthStore } from 'context/AuthStore'
import NoMatch from 'pages/NoMatch/NoMatch'
import {
  MANAGER,
  MANAGER_AUTO_DAMU,
  ROP,
  ROP_CS,
  SPP,
  SUPER_HEAD_SALES
} from 'constants/roles'
import { HomeStoreProviderManager } from 'context/HomeStore/Manager'
import { HomeStoreProviderSpp } from 'context/HomeStore/SPP'

const PrivateRoute = ({
  byRole = null,
  component: Component,
  componentProps = {},
  ...rest
}) => {
  const { authStore } = useAuthStore()
  return (
    <Route
      {...rest}
      render={props => {
        if (!authStore.isLoggedIn) {
          return <Redirect to={SIGN_IN_PATH} />
        }

        if (!byRole) {
          return <Component {...props} {...componentProps} />
        }
        console.log('authStore.user.role', authStore.user.role)
        if (byRole.includes(authStore.user.role)) {
          if ([MANAGER, MANAGER_AUTO_DAMU].includes(authStore.user.role)) {
            return (
              <HomeStoreProviderManager>
                <Component {...props} {...componentProps} />
              </HomeStoreProviderManager>
            )
          }

          if ([ROP, ROP_CS, SUPER_HEAD_SALES].includes(authStore.user.role)) {
            return (
              <HomeStoreProviderRop>
                <Component {...props} {...componentProps} />
              </HomeStoreProviderRop>
            )
          }

          if (authStore.user.role === SPP) {
            return (
              <HomeStoreProviderSpp>
                <Component {...props} {...componentProps} />
              </HomeStoreProviderSpp>
            )
          }
        } else {
          return <NoMatch />
        }

        return <NoMatch />
      }}
    />
  )
}

export default PrivateRoute

export const SubPrivateRoute = ({
  byRole = null,
  component: Component,
  componentProps = {},
  ...rest
}) => {
  const { authStore } = useAuthStore()
  return (
    <Route
      {...rest}
      render={props =>
        authStore.isLoggedIn && byRole.includes(authStore.user.role) ? (
          <Component {...props} {...componentProps} />
        ) : (
          <NoMatch />
        )
      }
    />
  )
}
